import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.kissinvoice').factory('KissInvoiceSvc', KissInvoiceSvc);

    KissInvoiceSvc.$inject = ['KissInvoiceDA'];

    /* @ngInject */
    function KissInvoiceSvc(KissInvoiceDA) {
        var exports = {
            searchInvoices: searchInvoices,
            searchPreInvoices: searchPreInvoices
        };

        return exports;

        ////////////////
        /**
         * Recherche de factures sur la docrepo.
         *
         * @param {Object} InvoicesFilter - Critères de recherche
         */
        function searchInvoices(invoicesFilter) {
            return KissInvoiceDA.searchInvoices(invoicesFilter);
        }

        /**
         * Recherche des pré-factures.
         *
         * @param {Object} preInvoicesFilter - Critères de recherche
         */
        function searchPreInvoices(preInvoicesFilter) {
            var filter = preInvoicesFilter.preparBeforeSearch();
            return KissInvoiceDA.searchPreInvoices(filter);
        }
    }
})();
